<template>
  <div class="unpackSale-list">
    <QueryFrame
      :addText="addText"
      :current="page"
      @addNew="download"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :disablePage="disablePage"
      :count="count"
    >
      <div slot="queryParams" class="queryContainer">
				<div class="queryItem">
          <label>销售单号:</label>
          <lk-input class="item" v-model="query.orderNo" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
          <!-- <label>商品搜索:</label>
          <lk-input class="item" v-model="query.nameMix" clearable placeholder="可按商品名、通用名、编码、助记码搜索" /> -->
        </div>
        <div class="queryItem">
          <label>批号:</label>
          <lk-input class="item" v-model="query.batchCode" clearable placeholder="请输入" />
        </div>
        <div class="queryItem">
          <label>生产企业:</label>
          <lk-input class="item" v-model="query.manufacturer" clearable placeholder="生产厂家" />
        </div>
				<div class="queryItem">
            <label>销售时间段:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.saleTimeRange' ></timeStampDatePicker>
        </div>
        <div class="queryItem">
            <label>拆零时间段:</label>
            <timeStampDatePicker type='daterange' placeholder=" 请选择" class="item" v-model.trim='query.unpackTimeRange' ></timeStampDatePicker>
        </div>
        <div class="queryItem" v-if="roleType!==2">
            <label >门店:</label>
            <storeListSelect class="item" v-model="query.storeIds"></storeListSelect>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="search-btn" @click="handleSearch(false, getDetailSummary)">查询</lk-button>
          <lk-button @click="clear">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <div class="summary-container">
          <div class="summary-title">合计</div>
          <div class="summary-item">
            <div class="Report-total-item-label">销售数量：</div>
            <div class="summary-item-value">{{summary.allGoodsCountDisplay}}</div>
          </div>
          <div class="summary-item">
            <div class="Report-total-item-label">含税金额：</div>
            <div class="summary-item-value">{{summary.allAmountDisplay}}</div>
          </div>
          <div class="summary-item">
            <div class="Report-total-item-label">不含税金额：</div>
            <div class="summary-item-value">{{summary.allAmountWithoutTaxDisplay}}</div>
          </div>
          <div class="summary-item">
            <div class="Report-total-item-label">含税成本：</div>
            <div class="summary-item-value">{{summary.allCostAmountDisplay}}</div>
          </div>
          <div class="summary-item">
            <div class="Report-total-item-label">不含税成本：</div>
            <div class="summary-item-value">{{summary.allCostAmountWithoutTaxDisplay}}</div>
          </div>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import unpack from '../../services/unpack';
import utils from '../../libs/utils';

export default {
  name: 'unpackSale',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      summary: {},
      query: {
        saleTimeRange: [],
        unpackTimeRange: [],
      },
      columns: [
        {
          title: '序号', key: 'index', minWidth: 116, tooltip: true, fixed: 'left', type: 'index',
        },
        {
          title: '销售单号', key: 'orderNo', minWidth: 116, tooltip: true,
        },
        {
          title: '行号', key: 'lineNum', minWidth: 116, tooltip: true,
        },
        {
          title: '通用名', key: 'approvedDrugNames', minWidth: 116, tooltip: true,
        },
        {
          title: '商品编码', key: 'drugSerialCode', minWidth: 116, tooltip: true,
        },
        {
          title: '规格', key: 'specifications', minWidth: 116, tooltip: true,
        },
        {
          title: '剂型', key: 'dosageForm', minWidth: 116, tooltip: true,
        },
        {
          title: '生产厂家', key: 'manufacturer', minWidth: 116, tooltip: true,
        },
        {
          title: '原单位', key: 'originMinPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '拆零单位', key: 'unpackMinPkgUnitName', minWidth: 116, tooltip: true,
        },
        {
          title: '生产日期', key: 'manufactureDate', minWidth: 116, tooltip: true,
        },
        {
          title: '有效期', key: 'expireDate', minWidth: 116, tooltip: true,
        },
        {
          title: '仓库', key: 'storehouseName', minWidth: 116, tooltip: true,
        },
        {
          title: '货位', key: 'allocationName', minWidth: 116, tooltip: true,
        },
        {
          title: '批次', key: 'goodsBatch', minWidth: 116, tooltip: true,
        },
        {
          title: '批号', key: 'goodsLot', minWidth: 116, tooltip: true,
        },
        {
          title: '销售数量', key: 'goodsCount', minWidth: 116, tooltip: true,
        },
        {
          title: '实际销售单价', key: 'realPrice', minWidth: 116, tooltip: true,
        },
        // {
        //   title: '销售总价', key: 'amount', minWidth: 116, tooltip: true,
        // },
        {
          title: '销项税率', key: 'outputTaxRate', minWidth: 116, tooltip: true,
        },
        {
          title: '税额', key: 'totalOutputTaxDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '含税金额', key: 'amountDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '不含税金额', key: 'totalPriceAfterTaxDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '含税成本', key: 'costAmountDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '不含税成本', key: 'costAmountWithoutTaxDisplay', minWidth: 116, tooltip: true,
        },
        {
          title: '销售时间', key: 'createTime', minWidth: 130, tooltip: true,
        },
        {
          title: '营业员', key: 'createUserName', minWidth: 116, tooltip: true,
        },
        {
          title: '经办人', key: 'createUserName', minWidth: 130, tooltip: true,
        },
        {
          title: '复核人', key: 'reviewerName', minWidth: 116, tooltip: true,
        },
      ],
      tableData: [],
    };
  },
  computed: {
    addText() {
      return (this.handlePermission('unpackSaleRecordExport') ? '导出Excel' : '');
    },
  },
  methods: {
    paramsChange() {
      if (this.params.saleTimeRange && this.params.saleTimeRange.length === 2) {
        this.params.startTime = this.params.saleTimeRange[0];
        this.params.endTime = this.params.saleTimeRange[1];
      }
      if (this.params.unpackTimeRange && this.params.unpackTimeRange.length === 2) {
        this.params.unpackStartTime = this.params.unpackTimeRange[0];
        this.params.unpackEndTime = this.params.unpackTimeRange[1];
      }
    },
    getDetailSummary() {
      this.paramsChange();
		  unpack.getUnpackDetailSummary(this.params).then((res) => {
        if (res.data.status === 200) {
      	  this.summary = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
		  }).catch((err) => {
        utils.handleError(err);
      });
	  },
    download() {
      this.paramsChange();
      unpack.downloadUnpackDetailReport(this.params)
        .then((res) => {
          const isEXCLE = res.headers['content-type'] === 'application/vnd.ms-excel;charset=GBK';
          if (!isEXCLE) {
            utils.blobResponseToJson(res).then((errorMsg) => {
              this.$Message.error(errorMsg.error);
            });
          } else {
            utils.downFile(res.data, 'unpackSaleRecord.xlsx', res.data.type);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.size = this.size;
      this.params.page = this.page;
      this.paramsChange();
      unpack.getUnpackDetailReportList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          const { data } = res.data;
          this.count = data.count;
          data.list.forEach((item) => {
            const { costAmountDisplay, costAmountWithoutTaxDisplay } = item;
            Object.assign(item.saleOrderDetail, { costAmountDisplay, costAmountWithoutTaxDisplay });
            if (item.saleOrderDetail) {
              item.saleOrderDetail.manufactureDate = utils.exchangeTime(item.saleOrderDetail.manufactureDate);
              item.saleOrderDetail.expireDate = utils.exchangeTime(item.saleOrderDetail.expireDate);
              item.saleOrderDetail.createTime = utils.exchangeTimeToSecond(item.saleOrderDetail.createTime);
            }
            if (item.inventoryUnpackRecord) {
              item.saleOrderDetail.originMinPkgUnitName = item.inventoryUnpackRecord.originMinPkgUnitName;
              item.saleOrderDetail.reviewerName = item.inventoryUnpackRecord.reviewerName;
            }
            this.tableData.push(item.saleOrderDetail);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {
        saleTimeRange: [],
        unpackTimeRange: [],
      };
    },
  },
  mounted() {
    if (this.roleType !== 2) {
      this.columns.splice(0, 0, {
        title: '门店', key: 'storeName', minWidth: 116, tooltip: true,
      });
    }
    this.handleSearch(true, this.getDetailSummary);
  },
};
</script>

<style lang="less">
.unpackSale-list {
  .search-btn {
    margin-right: 10px;
  }
  .query-params-wrap {
    padding-bottom: 20px;
  }
  .second-row {
    margin-top: 10px;
  }
  .summary-container {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
    .summary-title {
      margin-right: 16px;
    }
    .summary-item {
        display: flex;
        margin-right: 16px;
      .summary-item-value {
        min-width: 20px;
      }
    }
  }
}

</style>
